import { DatePickerWUT } from '@wix/form-fields/wut';

export default DatePickerWUT;
